class DateCounter extends HTMLElement {
  constructor() {
    super();

    this.countdownDateAttr = null;
    this.countdownDate = null;
    this.days = null;
    this.hours = null;
    this.minutes = null;
    this.seconds = null;
    this.countdownTimer = null;
    this.timerEnded = null;
    this.splitDigits = false;
  }

  connectedCallback() {
    this.countdownDateAttr = this.getAttribute('data-end-date');
    this.countdownDate = this.parseDate(this.countdownDateAttr);
    if (isNaN(this.countdownDate)) {
      console.error('Invalid date format:', this.countdownDateAttr);
      return;
    }
    this.days = this.querySelector('[data-ref="days"]');
    this.hours = this.querySelector('[data-ref="hours"]');
    this.minutes = this.querySelector('[data-ref="minutes"]');
    this.seconds = this.querySelector('[data-ref="seconds"]');
    this.countdownTimer = this.querySelector('[data-ref="countdown-timer"]');
    this.timerEnded = this.querySelector('[data-ref="timer-ended"]');
    this.splitDigits = this.getAttribute('data-split-digits') === 'true';
    this.previewEnded = this.getAttribute('data-preview-ended') === 'true';

    // Si preview ended est activé, ne pas démarrer le timer
    if (this.previewEnded) return;

    this.updateCountdown();
    this.interval = setInterval(() => this.updateCountdown(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  parseDate(dateStr) {
    // Format attendu : 03/11/2025 14:30
    const dateTimeParts = dateStr.match(/(\d{2})\/(\d{2})\/(\d{4})\s(\d{2}):(\d{2})/);
    if (dateTimeParts) {
      const [_, day, month, year, hour, minute] = dateTimeParts;
      return new Date(year, month - 1, day, hour, minute);
    }

    // Si le format n'est pas reconnu, retourne une date invalide
    return new Date('Invalid Date');
  }

  /**
   * Affiche une valeur dans un élément.
   * Si splitDigits est activé, chaque chiffre est dans son propre span.countdown__digit-box
   * Sinon, affichage classique en textContent.
   */
  renderValue(element, value) {
    if (!element) return;

    const str = String(value);

    if (this.splitDigits) {
      // Ne recréer le DOM que si le nombre de chiffres change
      const existingBoxes = element.querySelectorAll('.countdown__digit-box');
      if (existingBoxes.length !== str.length) {
        element.innerHTML = '';
        for (let i = 0; i < str.length; i++) {
          const box = document.createElement('span');
          box.className = 'countdown__digit-box';
          box.textContent = str[i];
          element.appendChild(box);
        }
      } else {
        // Mettre à jour les chiffres existants
        existingBoxes.forEach((box, i) => {
          if (box.textContent !== str[i]) {
            box.textContent = str[i];
          }
        });
      }
    } else {
      element.textContent = str;
    }
  }

  updateCountdown() {
    const now = new Date().getTime();
    const distance = this.countdownDate.getTime() - now;

    if (distance < 0) {
      this.countdownTimer.classList.add('hidden');
      if (this.timerEnded.dataset.showMessage === 'true') {
        this.timerEnded.classList.remove('hidden');
      } else {
        this.closest('[data-ref="countdown"]').classList.add('hidden');
      }

      clearInterval(this.interval);
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    // Affichage des jours, même s'ils sont à 0
    this.renderValue(this.days, days);
    this.renderValue(this.hours, hours.toString().padStart(2, '0'));
    this.renderValue(this.minutes, minutes.toString().padStart(2, '0'));
    this.renderValue(this.seconds, seconds.toString().padStart(2, '0'));
  }
}

customElements.define('date-counter', DateCounter);